import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';
import { Text, textFontStyles } from '@makemydeal/dr-ui-bricks-components';

const getBorderColor = ({ theme }: { theme: DefaultTheme }) => theme.uiBricks?.primaryBorderColor || '#808080';

export const ParticipantsInfoTable = styled.table`
    width: 100%;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    border: 1px solid ${getBorderColor};
    border-radius: 4px;
    background-color: ${({ theme }) => theme.uiBricks?.pageBackgroundColor || '#ffffff'};
`;

export const ParticipantsInfoHeaderCell = styled.th`
    text-align: left;
    vertical-align: middle;
    padding: 6px 12px;
    background-color: #f4f4f4;
    border-bottom: 1px solid ${getBorderColor};
    ${textFontStyles('small', 'bold')};
    color: ${({ theme }) => theme.uiBricks?.headlineFontColor || '#000000'};

    &:first-child {
        width: 22%;
        border-right: 1px solid ${getBorderColor};
        border-top-left-radius: 4px;
    }

    &:last-child {
        border-top-right-radius: 4px;
    }
`;

export const ParticipantsInfoCell = styled.td`
    vertical-align: middle;
    padding: 12px;
    overflow-wrap: anywhere;
    ${textFontStyles('small', 'regular')};
    color: ${({ theme }) => theme.uiBricks?.primaryFontColor || '#000000'};

    &:first-child {
        border-right: 1px solid ${getBorderColor};
    }
`;

export const CustomerDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const CustomerDetailLine = styled(Text)`
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 6px;
    color: ${({ theme }) => theme.uiBricks?.primaryFontColor || '#000000'};
`;

export const Separator = styled.span`
    color: ${({ theme }) => theme.uiBricks?.secondaryFontColor || '#949494'};
`;
